import style from "./Title.module.scss"
interface Props {
    children: React.ReactNode
}
export const Title = ({ children }: Props) => {
  return <h1 className={style.Title}>{children}</h1>;
}